/**
 * @platform/errorzen-react
 *
 * The presentational `ErrorState` (wraps zendesign `StateDisplay`;
 * primitive/structural props only -- no `ApiError` dependency at the type
 * level; it never reports) and `MetricErrorState` (the compact KPI/metric-tile
 * counterpart, for surfaces too small for `StateDisplay`'s centered block),
 * the pure `toErrorPresentation` wire -> presentation normalizer (known code
 * -> FE copy map, validated problem -> wire title + safe detail, anything
 * else -> generic copy), and `routeError` (centralized error-class router:
 * AUTH.* -> reauth, ACCESS.* -> access-denied, VALIDATION.* -> field errors,
 * RESOURCE.NOT_FOUND -> not-found, RESOURCE.RATE_LIMITED -> retry-aware
 * ErrorState, everything else -> the generic ErrorState surface).
 *
 * Epic ASC-6291 (T13, ASC-6339, ASC-6756). Contract:
 * __tests__/errorzen-react.contract.test.ts.
 */

export {
  ACCESS_DENIED_COPY,
  AccessDeniedState,
  isAccessDeniedError,
  type AccessDeniedStateProps,
} from './src/AccessDeniedState'
export { GENERIC_ERROR_COPY, resolveErrorCopy, type ErrorCopy } from './src/copy'
export { ErrorState, type ErrorStateProps } from './src/ErrorState'
export { MetricErrorState, type MetricErrorStateProps } from './src/MetricErrorState'
export {
  routeError,
  type ErrorSurface,
  type FieldError,
  type RoutableError,
  type RoutedError,
} from './src/routeError'
export { toErrorPresentation, type ErrorPresentation } from './src/toErrorPresentation'
